import Common from '../../Common';

export interface CompanyDid {
	id: id
	pbx_user_id: id
	e164: string
	ast_language_id: string
	type: "fixed" | "cell"
	label: string
}

const Did = class extends Common {
	// @ts-expect-error please i just want to build this project
	async browse(companyId: id): CustomResponse<CompanyDid[]> {
		return this.get(`/company/${companyId}/did`)
	}

	// @ts-expect-error please i just want to build this project
	async read(companyId: id, didId: id): CustomResponse<CompanyDid> {
		return this.get(`/company/${companyId}/did/${didId}`)
	}

	async readAvailable(companyId: id) {
		return this.get(`/company/${companyId}/did/available`)
	}
}

export default Did
